import { render } from "./DataQuery.vue?vue&type=template&id=e83f125e&scoped=true"
import script from "./DataQuery.vue?vue&type=script&lang=js"
export * from "./DataQuery.vue?vue&type=script&lang=js"

import "./DataQuery.vue?vue&type=style&index=0&id=e83f125e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e83f125e"]])

export default __exports__